import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';
import { Icon } from '@cld/icon';
import { STATES, ICON_SIZES } from '../../constants';
import StepLabel from './StepLabel';
import StepIcon from './StepIcon';

const disabledCss = css`
  opacity: 0.35;
`;

export const StyledStep = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  cursor: ${(props) => (props.disabled || !props.onClick ? '' : 'pointer')};
  ${(props) => props.disabled && disabledCss};
`;

const IconWrapper = styled.div`
  min-height: ${ICON_SIZES.ACTIVE}px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Step = ({ label, children, ...props }) => {
  const state = useMemo(
    () => ({
      [STATES.DISABLED]: props[STATES.DISABLED],
      [STATES.COMPLETED]: props[STATES.COMPLETED],
      [STATES.ERROR]: props[STATES.ERROR],
      [STATES.ACTIVE]: props[STATES.ACTIVE],
      [STATES.INCOMPLETE]: props[STATES.INCOMPLETE],
    }),
    [props]
  );

  const calcChildren = useMemo(() => {
    if (state.error) {
      return <Icon name="error" />;
    }

    if (state.completed) {
      return <Icon name="done" />;
    }

    return children;
  }, [state, children]);

  return (
    <StyledStep {...props} data-test="step">
      <IconWrapper>
        <StepIcon {...state}>{calcChildren}</StepIcon>
      </IconWrapper>
      <StepLabel {...state}>{label}</StepLabel>
    </StyledStep>
  );
};

export default React.memo(Step);
